import React from 'react';
import { Smartphone, VolumeX, ShieldAlert } from 'lucide-react';
export function AgitationSection() {
  const painPoints = [{
    icon: <Smartphone className="w-8 h-8 text-warm-accent" data-id="element-1" />,
    title: 'El Secuestro',
    description: 'La mirada perdida y agresividad instantánea al apagar.'
  }, {
    icon: <VolumeX className="w-8 h-8 text-warm-accent" data-id="element-2" />,
    title: 'El Agotamiento',
    description: 'Tu garganta duele de gritar y tu paciencia está al límite.'
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-warm-accent" data-id="element-3" />,
    title: 'La Culpa No-Escrita',
    description: 'Sentir que eres el policía de tus hijos y no su refugio.'
  }];
  return <section className="relative py-10 px-4 overflow-hidden" data-id="element-4">
      {/* Background Image with Dark Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-5">
        <img src="https://cdn.magicpatterns.com/uploads/9gWV1YiCETaKYToVLJ5gJA/imagen_1.png" alt="" className="w-full h-full object-cover" data-id="element-6" />
        <div className="absolute inset-0 bg-deep-blue/85" data-id="element-7"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-8">
        <div className="text-center mb-6" data-id="element-9">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-10">
            Las 7:00 PM no deberían ser una zona de guerra
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11">
          {painPoints.map((point, index) => <div key={index} className="bg-white/95 backdrop-blur-sm p-8 rounded-3xl border border-white/20 flex flex-col items-center text-center" data-id="element-12">
              <div className="w-16 h-16 bg-cream rounded-2xl shadow-sm flex items-center justify-center mb-5" data-id="element-13">
                {point.icon}
              </div>
              <h3 className="text-2xl font-bold text-deep-blue mb-3" data-id="element-14">
                {point.title}
              </h3>
              <p className="text-deep-blue/70 text-lg leading-relaxed" data-id="element-15">
                {point.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}